import queryString from 'querystring';
import { axiosClient } from './axiosClient';
import { TOptionsQuery } from 'types/common';
import { TSurveyProgress } from '../types/surveyProgress/surveyProgress';

export const surveyProgressApi = {
  getListSurveyProgress: (params: TOptionsQuery<TSurveyProgress>) => {
    const url = '/survey-progress';
    const query = queryString.stringify(convertSurveyParam(params));
    return axiosClient.get(`${url}?${query}`);
  },
  deleteSurveyProgress: (id: string, surveyId: string) => {
    const url = `/survey-progress/${id}/${surveyId}`;
    return axiosClient.delete(url);
  },
  updateSurveyProgress: (params: { id: string; data: TSurveyProgress }) => {
    const url = `/survey-progress/${params.id}`;
    return axiosClient.put(url, params.data);
  },
  getListSurveyByEmployee: (id: string) => {
    const url = `/survey-progress/getByEmployee/${id}`;
    return axiosClient.get(url);
  },
  addListEmployeeJoinSurvey: (data: any[]) => {
    const url = `/survey-progress/multi`;
    return axiosClient.post(url, data);
  },
};

export const convertSurveyParam = (params: TOptionsQuery<TSurveyProgress>) => {
  const { surveyIdGroup, ...restParams } = params;

  const serializableParams: any = { ...restParams };

  if (surveyIdGroup && surveyIdGroup.length > 0) {
    serializableParams.facilityIds = surveyIdGroup.map((facility) => facility.facilityId);
  }

  return serializableParams;
};
